import { useEffect, useState } from "react";
import { useUser } from "../../../../context/userContext";
import NewCustomRadio from "../../../../components/common/radioButtons/NewCustomRadio";
import { Box } from "../../../../components/styled/Elements";
import FloatingInput from "../../../../components/common/inputFields/FloatingInput";
import {
  PlaceholderImg,
  SearchIcon,
} from "../../../../components/styled/AllImages";
import { useSelector } from "react-redux";

const ASSET_URL = process.env.REACT_APP_ASSET_URL;

export const TransferTo = ({ onSelect, selected, t, language }) => {
  const { user } = useUser();
  const [userDepartment, setUserDepartment] = useState({
    name: "",
    subLabel: "",
    departmentId: null,
  });

  useEffect(() => {
    if (user) {
      const name = `${
        language === "en"
          ? user?.department?.name_en
          : user?.department?.name_ar
      }`;
      const subLabel =
        language === "en"
          ? user?.office_location?.name_en
          : user?.office_location?.name_ar;
      setUserDepartment({ name, subLabel, departmentId: user?.department?.id });
    }
  }, [language, user]);

  return (
    <ul className="option-list">
      <li className="option-item">
        <div className="option-text py-1 px-0 px-md-2">
          <NewCustomRadio
            name="department"
            label={userDepartment.name}
            subLabel={userDepartment.subLabel}
            value={userDepartment.departmentId}
            checked={selected == userDepartment.departmentId}
            onChange={onSelect}
          />
        </div>
      </li>
      <li className="option-item">
        <div className="option-text py-2 px-0 px-md-2">
          <NewCustomRadio
            name="department"
            label={t("other_department")}
            value={"other_departments"}
            checked={selected == "other_departments"}
            onChange={onSelect}
          />
        </div>
      </li>
    </ul>
  );
};

export const SelectDepartment = ({ onSelect, selected, t }) => {
  const { user } = useUser();
  const { branchesDeps } = useSelector((state) => state.helper);
  const [filteredBranchesDeps, setFilteredBranchesDeps] = useState([]);

  useEffect(() => {
    if (branchesDeps) {
      setFilteredBranchesDeps(branchesDeps);
    }
  }, [branchesDeps]);

  const handleSearch = (e) => {
    const inputValue = e.target.value.trim().toLowerCase();

    if (inputValue === "") {
      setFilteredBranchesDeps(branchesDeps);
    } else {
      const filtered = branchesDeps.filter((res) =>
        res.name.toLowerCase().includes(inputValue)
      );
      setFilteredBranchesDeps(filtered);
    }
  };

  return (
    <>
      <Box className="mb-3 mx-3">
        <FloatingInput
          name="search"
          type="input"
          fieldType="text"
          label={t("search")}
          placeholder={t("search")}
          icon={SearchIcon}
          onChange={handleSearch}
        />
      </Box>
      <ul className="option-list">
        {filteredBranchesDeps
          ?.filter((dept) => dept?.id !== user?.department?.id)
          ?.map((dept, i) => (
            <li key={i} className="option-item">
              <div className="option-text py-1 px-0 px-md-2">
                <NewCustomRadio
                  name="department"
                  label={t(dept.name)}
                  subLabel={t(dept.subLabel)}
                  value={dept.id}
                  checked={selected === dept.id}
                  onChange={onSelect}
                />
              </div>
            </li>
          ))}
      </ul>
    </>
  );
};

export const SelectMember = ({ onSelect, selected, t, usersListByDepId }) => {
  const { user } = useUser();
  const [filteredUsersList, setFilteredUsersList] = useState([]);

  useEffect(() => {
    if (usersListByDepId) {
      setFilteredUsersList(usersListByDepId);
    } else {
      setFilteredUsersList([]);
    }
  }, [usersListByDepId]);

  const handleSearch = (e) => {
    const inputValue = e.target.value.trim().toLowerCase();

    if (!usersListByDepId) return;

    if (inputValue === "") {
      setFilteredUsersList(usersListByDepId);
    } else {
      const filtered =
        usersListByDepId &&
        usersListByDepId.filter((user) =>
          user.name.toLowerCase().includes(inputValue)
        );
      setFilteredUsersList(filtered);
    }
  };
  return (
    <>
      <Box className="mb-3 mx-3">
        <FloatingInput
          name="search"
          type="input"
          fieldType="text"
          label={t("search")}
          placeholder={t("search")}
          icon={SearchIcon}
          onChange={handleSearch}
        />
      </Box>
      <ul className="option-list">
        {filteredUsersList?.map((member, i) => (
          <li key={member.name} className="option-item">
            <div className="option-text py-1 px-0 px-md-2">
              <NewCustomRadio
                name="trans_user_select"
                label={`${t(member.name)} ${
                  Number(user?.id) === Number(member.id) ? `(${t("me")})` : ""
                }`}
                subLabel={member.subLabel}
                value={member.id}
                checked={selected === member.id}
                onChange={onSelect}
                disabled={user?.id == member?.id}
                avatar={
                  member.profile
                    ? `${ASSET_URL}/${member.profile}`
                    : PlaceholderImg
                }
              />
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};
